export const NECKLACE = Object.freeze({
    STANDARD: Symbol('Standard'),
    SPACED: Symbol('Spaced'),
    SIDEWAYS: Symbol('Sideways'),
    VERTICAL: Symbol('Vertical'),
});

export const BRACELET = Object.freeze({
    STANDARD: Symbol('Standard'),
    SPACED: Symbol('Spaced'),
    SIDEWAYS: Symbol('Sideways'),
});

export const CHARM = Object.freeze({
    ONELINE: Symbol('One line'),
    TWOLINES: Symbol('Two lines'),
    VERTICAL: Symbol('Vertical line'),
});

export const GOLD = Object.freeze({
    YG: Symbol('Yellow Gold'),
    WG: Symbol('White Gold'),
    RG: Symbol('Rose Gold'),
});

export const NECKLACELENGTH = Object.freeze({
    LENGTH15: Symbol('15 inch'),
    LENGTH18: Symbol('18 inch'),
    LENGTH21: Symbol('21 inch'),
});

export const CHAIN = Object.freeze({
    CABLE: Symbol('Cable chain'),
    BEAD: Symbol('Bead chain'),
    BUTCH: Symbol('Butch chain'),
});

export const EARRING = Object.freeze({
    ONE: Symbol('One earring'),
    PAIR: Symbol('Pair of earrings'),
});

export const MAX_NECKLACE_LETTERS_PER_LINE = 10;
export const MAX_BRACELET_LETTERS_PER_LINE = 7;
export const MAX_CHARM_LETTERS_PER_LINE = 6;
export const MAX_EARRING_LETTERS_PER_LINE = 4;
export const MAX_RING_LETTERS_PER_LINE = 3;

export const ASSETS_CDN = '//dfaankvzyirrl.cloudfront.net/website/customizer';
